import { render, staticRenderFns } from "./transferLogOut.vue?vue&type=template&id=c1c4e742&scoped=true"
import script from "./transferLogOut.vue?vue&type=script&lang=js"
export * from "./transferLogOut.vue?vue&type=script&lang=js"
import style0 from "./transferLogOut.vue?vue&type=style&index=0&id=c1c4e742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c4e742",
  null
  
)

export default component.exports